import { debounce, DebouncedFunc } from 'lodash';
import { useEffect, useMemo, useRef } from 'react';

const useDebounce = <TFunction extends (...args: any[]) => any>(callback: TFunction, ms: number = 1000) => {
    const ref = useRef<TFunction>(callback);

    useEffect(() => {
        ref.current = callback;
    }, [callback]);

    const debouncedCallback = useMemo(() => {
        if (!ref.current) return undefined;
        return debounce(ref.current, ms);
    }, [ms]);

    useEffect(() => {
        return () => {
            debouncedCallback?.cancel();
        };
    }, [debouncedCallback]);

    return debouncedCallback as DebouncedFunc<TFunction>;
};

export default useDebounce;
